module.exports = __webpack_public_path__ + "img/c5201901.d13c4a26.jpg";